


export const chat = {
    CHAT_ROOM_TYPE:{
        FRAPPE_CHANNEL:2
    },
    CHAT_ENC_KEY :  '572140014b67f20f1c66fac2b87bcca8572140014b67f20f1c66fac2b87bcca8',
    CHAT_IV_HEX : '73616e6a61792e6b73616e6a61792e6b',
}